import type { FaqPiece } from "@workspace/crystallize/generated/discovery/";
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "@workspace/ui/components/accordion";

export default function Faq({ faq }: FaqPiece) {
	return (
		<section className="mx-auto w-full max-w-7xl px-4">
			<h2 className="mb-6 text-center text-3xl text-primary">
				Ofte stilte spørsmål
			</h2>
			<Accordion type="single" collapsible className="w-full">
				{faq?.map((faqItem, index) => (
					<AccordionItem
						key={`item-${
							// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
							index
						}`}
						value={`item-${index}`}
					>
						<AccordionTrigger className="text-left text-2xl">
							{faqItem?.question}
						</AccordionTrigger>
						<AccordionContent>
							<div
								// biome-ignore lint/security/noDangerouslySetInnerHtml: <We are receiving html from Crystallize>
								dangerouslySetInnerHTML={{ __html: faqItem?.answer ?? "" }}
								className="prose prose-sm max-w-none"
							/>
						</AccordionContent>
					</AccordionItem>
				))}
			</Accordion>
		</section>
	);
}
